<div *transloco="let transloco" class="flex">
  <p-select
    (onChange)="this.props.change && this.props.change(this.field, $event)"
    [editable]="this.props.editable || false"
    [filterBy]="this.props.canFilter ? 'searchText' : undefined"
    [filter]="this.props.canFilter"
    [formControl]="this.formControl"
    [formlyAttributes]="this.field"
    [group]="!!this.props.groupProp"
    [ngClass]="{
      'ng-dirty ng-invalid p-invalid': this.showError
    }"
    [optionGroupChildren]="this.props.groupChildrenProp || 'group'"
    [optionGroupLabel]="this.props.groupLabelProp || 'label'"
    [optionLabel]="this.props.optionLabel || 'label'"
    [optionValue]="this.props.optionValue || 'value'"
    [options]="
      (this.props.options | formlySelectOptions: this.field | async)!
        | libSelectSearchText
          : undefined
          : undefined
          : this.props.groupChildrenProp
          : this.props.searchByValue
    "
    [placeholder]="transloco(this.props.placeholder || '') || '&nbsp;'"
    [readonly]="this.props.readonly"
    [scrollHeight]="this.props.scrollHeight || '500px'"
    [showClear]="this.props.readonly == undefined ? this.props.showClear : !this.props.readonly"
    [virtualScrollItemSize]="this.props.virtualScrollSize"
    [virtualScroll]="this.props.virtualScroll"
    appendTo="body"
    class="w-full"
    fluid>
    <ng-template #item let-item>
      {{ transloco(item['label']) }}
    </ng-template>
    <ng-template #selectedItem let-selectedItem>
      {{ transloco(selectedItem['label']) }}
    </ng-template>
    <ng-template #group let-group>
      {{ transloco(group['label']) }}
    </ng-template>
  </p-select>
</div>
